var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "image-slider-wrapper", class: [_vm.sliderId] },
    [
      _c(
        "swiper",
        {
          ref: "slider",
          staticClass: "image-slider",
          class: ["image-slider--count-" + _vm.images.length],
          attrs: { options: _vm.swiperOptions },
          on: {
            "slide-change-transition-start":
              _vm.onSwiperSlideChangeTransitionStart,
            "slide-change-transition-end": _vm.onSwiperSlideChangeTransitionEnd,
          },
        },
        [
          _vm._l(_vm.images, function (image, index) {
            return _c("swiper-slide", { key: index }, [
              _c(
                "div",
                {
                  staticClass: "image-slider__slide",
                  on: { click: _vm.sliderClicked },
                },
                [
                  !_vm.loop
                    ? _c(
                        "div",
                        {
                          key: image.sizes.large,
                          staticClass: "image-slider__slide__image",
                        },
                        [
                          _c(
                            "lazy-background-image",
                            { attrs: { src: image.sizes.large } },
                            [
                              _vm.lightbox
                                ? _c("a", {
                                    attrs: { href: image.url },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.didSelectOpenImageGallery(
                                          index
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          key: image.sizes.large,
                          staticClass: "image-slider__slide__image",
                        },
                        [
                          _c("div", {
                            key: image.sizes.large,
                            staticClass: "image",
                            style: {
                              backgroundImage: "url(" + image.sizes.large + ")",
                            },
                            attrs: { href: image.url, "data-index": index },
                          }),
                        ]
                      ),
                ]
              ),
            ])
          }),
          _vm._v(" "),
          _vm.showPagination
            ? _c("div", {
                staticClass: "swiper-pagination",
                attrs: { slot: "pagination" },
                slot: "pagination",
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showNavigation
        ? _c("div", {
            staticClass: "swiper-button-prev",
            attrs: { slot: "button-prev" },
            slot: "button-prev",
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showNavigation
        ? _c("div", {
            staticClass: "swiper-button-next",
            attrs: { slot: "button-next" },
            slot: "button-next",
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/ImageSlider.vue